import { PAY_OPTION_MPESA, V1 } from "../data/constants";
import { SMARTCASH_SECURE } from "../data/smartcash";
import { v2, V4 } from "../data/constants";
import { getIsGuestUser } from "../utils/commonUtils";
import { PG_LABELS } from "../features/PaymentGatewayCard/constant";

export const BASE_API_URL = "/api/b2c-backend";
export const baseName = "";
export const S3_CDN_URL = "https://assets-africa.airtelstream.net/";
export const EVENT_SERVICE_BASE_URL = "/event-service";

export const ENDPOINTS = {
  LOGIN: {
    sendOtp: (version:string = v2) => `/${version}/send-otp`,
    resendOTP: () => getIsGuestUser() ? `/v3/resend-otp` : `/v2/send-otp`,
    resendOtp: (version:string = V4) => `/${version}/resend-otp`,
    verifyOtp: (version:string = v2) => `/${version}/verify-otp`,
    secureSmsToken: () => `/v1/onboarding/get-sms-token`,
    secureSmsVerifyToken: () => `/v1/onboarding/verify-token-status`
  },
  BALANCE: {
    //checkAMBalance: () => `/v1/am/balance`,
    checkAMBalance: () => `/v2/am/balance`,
    checkGSMBalance: () => `/v1/gsm/balance`,
  },

  processTxn: () => `/v1/process-transaction`,
  processTxnV2: () => `v2/process-transaction`,
  processTxnV3: `v3/process-transaction`,
  processTxnV4: `v4/process-transaction`,
  txnFee: () => `/v1/transaction/fee`,
  lob: "/v1/check-lob",
  getMPESAProcessTxn: (paymentMode: string) => getIsGuestUser() ? ENDPOINTS.processTxnV4 : (paymentMode === PAY_OPTION_MPESA || paymentMode === SMARTCASH_SECURE) ? ENDPOINTS.processTxnV3 : ENDPOINTS.processTxnV2(),
  AM: {
    validatePin: () => `/v1/am/validate-pin`,
    isSufficientBal: () => 'v1/am/wallet-balance-sufficient',
    transactionHistory: () => '/v2/transaction-history?page=0&size=1&sort=string',
    setPin: () => `/v1/am/user/set-pin`,
    setQuestion: () => `/v1/am/set-security-question`,
    getQuestions: () => `/v1/am/security-questions`,
    changeAmPin: () => '/v1/am/user/change-pin',
    getCurrentQuestion: () => `/v1/am/security-question`,
    validateSecurityAns: () => `/v1/am/validate-security-answer`,
    validateDocId: () => `/v1/am/validate-document-id`,
    forgotPin: () => `/v1/am/user/forget-pin`,
    unlockPin: () => `/v1/am/user/unlock-pin`
  },

  HOME: {
    getUserInfo: () => `/v1/user-info`,
    getAMProfile: () => getIsGuestUser() ? `/v2/am/user` : `/v1/am/user`,
    getGuestAMProfile: () => `/v2/am/user`,
    captureIncentive: () => `/v1/capture-incentive`,
    setUserConfig: () => `/v1/set-user-config`,
  },
  CONFIG: {
    fetchConfig: (source: string) =>
      `/v1/config?config-code=${source}`,
    launchConfig: "v1/launch-config",
    limitConfig:"v1/transaction-limit-config"
  },
  recentContacts: () => getIsGuestUser() ? "v1/poll-transaction-status" : "/v1/transaction-history",
  BUNDLE: {
    fetchBundles: () => `/v1/get-bundles`
  },
  FAVOURITES: {
    fetchFavourites: `/v1/favourites-by-category`,
    addFavourites: `/v1/favourite/add`,
    fetchAllFavourites: `/v1/favourites`,
    deleteFavourites: `/v1/favourite/delete`,
    editFavourites: `/v1/favourite/update`
  },
  betaFeatures: 'v1/features-available',
  betaUsers: 'v1/beta-users',
  getTranslations: 'v1/translation',
  PAY_BILL: {
    fetchCategories: "/v1/biller/categories",
    fetchBillers: (categoryCode: string = "") => `/v1/biller/category/${categoryCode}`,
    fetchSearchedBillers: `/v1/biller/search`,
    fetchBillerInfo: (billerCode: string = "") => `/v1/biller/${billerCode}`,
    fetchBillerInfoV2: `/v1/biller/fetch-by-code`,
    customerLookup: (billerCode: string = "") => `/v1/biller/lookup/${billerCode}`,
    processTrxn: `v1/biller/process-transaction`
  },
  CMS: "/v1/content",
  LOGOUT: "/v1/logout",
  SEND_MONEY: {
    getOperatorData: `/v1/operator-config/operators`,
    getNumberOperator: `/v1/operator`,
  },
  WITHDRAW_CASH: {
    getAgentInfo: ''
  },
  paymentOptions: "v1/payment-options",
  transactionFeeV2: "v2/transaction/fee",
  checkTransactionLimit: 'v1/transaction-amount-validation',
  pollStatus: 'v1/poll-transaction-status',
  sendOtp: '/v3/send-otp',
  resendOtp: '/v3/resend-otp',
  cucurrencyConverter: '/v1/cur-conversion',
  LOANS: {
    baseUrl: '/v1/loans',
    transactionHistory: '/transaction-history',
    products: '/products',
    applyLoan: '/apply'
  },
  userAttributes: '/v1/user/attributes',
  sendAirtelLiteLink: '/v1/send-link-sms',
  OTP_FLOW: {
    sendOTP: () => getIsGuestUser() ? 'v5/send-otp' : 'v4/send-otp',
    resendOTP: () => getIsGuestUser() ? 'v5/resend-otp' : 'v4/resend-otp',
    verifyOTP: () => getIsGuestUser() ? 'v5/verify-otp' : 'v4/verify-otp',
  },
  SMARTCASH: {
    fetchEncryptionKey: () => getIsGuestUser() ? 'v2/encryption/keys' : 'v1/encryption/keys',
    validateSmartcashAccount: () => getIsGuestUser() ? 'v2/validate-smartcash-account' : 'v1/validate-smartcash-account'
  },
  transactionStatus: (version: string = v2, paymentGateway: string = PG_LABELS.PAYSTACK_CAPS) => `${version}/transaction-status/callback/${paymentGateway}`,
  checkFeatureAvailable:(version:string=V1)=>`${version}/feature/availability`,
  getCDNURL: (imgName: string) => `${S3_CDN_URL}images/icons/${imgName}`
};


export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=com.airtel.africa.selfcare&hl=en`;
export const APP_STORE_URL = `https://apps.apple.com/us/app/my-airtel-africa/id1462268018`;